import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const Analysis = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.analysis.title')}
      contentType="analysis10"
      description={t('page.analysis.desc')}
      outputLabel={t('page.analysis.output')}
    />
  );
};
